import React from 'react';
import { Routes, Route, Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';

import ResultsForm from './Results'
import ErrorPage from '../NoModel/ErrorPage'

class STREAM_ICECHIPPage extends React.Component {

    render() {
        return (
            <div>
                <header className='landingpage-header'>
                    <div className='title-container'>
                        <h1 >Stream ICECHIP Videos </h1>
                    </div>
                </header>

                <main className='main'>
                    <Routes>
                        <Route path='*'>
                            <Route index element={<ResultsForm/>}/>
                            <Route path='SubmitForm' element={<ResultsForm/>}/>
                        </Route>
                        <Route path='*' element={<ErrorPage/>}/>
                    </Routes>
                </main>
            </div>
        );
    }
}

export default STREAM_ICECHIPPage;
